import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, map, filter } from 'rxjs/operators';
import { COUNTRY_CODE, NextWorkingDateResponse, NextWorkingDayService } from '@cemex-core/cmx-api';
import {
  OneClickOrdersActionTypes,
  OneClickSelectOrderAction,
} from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import {
  OneClickLoadNextWorkingDayAction,
  OneClickLoadNextWorkingDayCompleteAction,
  OneClickNextWorkingDayActionTypes,
} from '../actions/one-click-next-working-day.actions';
import * as moment from 'moment';
import { LanguageKey } from '@ordersnproducts/modules/shared/constants/language-key';

const nextWorkingDayFormats = {
  [LanguageKey.English]: 'YYYYMMDD',
  [LanguageKey.Spanish]: 'YYYYMMDD',
};

@Injectable()
export class OneClickNextWorkingDayEffects {
  loadNextWorkingDayCommand = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickOrdersActionTypes.SELECT_ORDER),
      map((action: OneClickSelectOrderAction) => {
        return new OneClickLoadNextWorkingDayAction(action.payload);
      }),
    ),
  );

  getNextWorkingDay = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickNextWorkingDayActionTypes.LOAD_NEXT_WORKING_DAY),
      map((action: OneClickLoadNextWorkingDayAction) => action.payload),
      filter((order) => !!order),
      switchMap((order) => {
        return this.nextWorkingDayService
          .getNextWorkingDay({
            shipmentLocationCode: order.jobsite.jobsiteCode,
            countryCode: order.salesArea.countryCode as COUNTRY_CODE,
            languageKey: LanguageKey.Spanish,
          })
          .pipe(
            map(
              (response: NextWorkingDateResponse) =>
                new OneClickLoadNextWorkingDayCompleteAction(
                  moment(response.dateAvailable, nextWorkingDayFormats[LanguageKey.Spanish]).toDate(),
                ),
            ),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private nextWorkingDayService: NextWorkingDayService,
  ) {}
}
